export { default } from "./ErrorIcon";
